import request from '@/utils/request'

export function confirmPatch (id, data) {
  const method = 'post'
  const url = `/patch/confirm/${id}`
  return request({
    url,
    method,
    data
  })
}